import { render, staticRenderFns } from "./EntityDownloadDashboard.vue?vue&type=template&id=7c796acc&scoped=true&"
import script from "./EntityDownloadDashboard.vue?vue&type=script&lang=js&"
export * from "./EntityDownloadDashboard.vue?vue&type=script&lang=js&"
import style0 from "./EntityDownloadDashboard.vue?vue&type=style&index=0&id=7c796acc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c796acc",
  null
  
)

export default component.exports